module.exports = __webpack_public_path__ + "static/media/win-reward-A04.fd42316f.png";